import { formatTicker } from '@toggle/toggle';
import React from 'react';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { EllipsisDetector } from '~/components/ellipsis-detector/EllipsisDetector';
import { useEntity } from '~/react-query-hooks/entities/useEntities';

import * as S from './EntityCell.styles';

export const EntityCell = ({ entityTag }: { entityTag: string }) => {
  const { data, isFetching, isError } = useEntity(entityTag);

  if (isFetching) {
    return <S.StyledLoader />;
  }

  if (isError || !data?.data) {
    return null;
  }

  const formattedTicker = formatTicker(data.data);
  const name = data.data.name_short || data.data.name;

  return (
    <S.Root data-testid="entity-cell">
      <AssetLogoContainer entity={data.data} size={28} />
      <S.FlexColumn>
        <EllipsisDetector label={name}>
          <S.TitleLabel>{name}</S.TitleLabel>
        </EllipsisDetector>
        <S.TickerLabel>{formattedTicker}</S.TickerLabel>
      </S.FlexColumn>
    </S.Root>
  );
};
